export const Sidenav = {
    items: [
        {
            title: 'SIDENAV.USERS',
            path: 'clients',
            weight: 100,
            icon: 'people',
            required_permissions: ['client.read'],
        },
        {
            title: 'SIDENAV.LOCATIONS',
            path: 'locations',
            weight: 110,
            icon: 'location_on',
            required_permissions: ['location.create'],
        },
        {
            title: 'SIDENAV.CATEGORIES',
            path: 'categories',
            weight: 115,
            icon: 'folder',
            required_permissions: ['post.create', 'category.create'],
        },
        {
            title: 'SIDENAV.UNITS',
            path: 'units',
            weight: 120,
            icon: 'business',
            required_permissions: ['unit.create'],
        },
        {
            title: 'SIDENAV.EVENTS',
            path: 'posts',
            queryParams: { type: 'event' },
            weight: 140,
            icon: 'event',
            required_permissions: ['post.create', 'event.create'],
        },
        {
            title: 'SIDENAV.OCCASIONS',
            path: 'posts',
            queryParams: { type: 'occasion' },
            weight: 150,
            icon: 'query_builder',
            required_permissions: ['post.create', 'occasion.create'],
        },
        {
            title: 'SIDENAV.PAGES',
            path: 'posts',
            queryParams: { type: 'page' },
            weight: 160,
            icon: 'speaker_notes',
            required_permissions: ['post.create', 'page.create'],
        },
        {
            title: 'SIDENAV.NEWS',
            path: 'posts',
            queryParams: { type: 'news' },
            weight: 170,
            icon: 'rss_feed',
            required_permissions: ['post.create', 'news.create'],
        },
        {
            title: 'SIDENAV.NOTIFICATIONS',
            path: 'notifications',
            weight: 160,
            icon: 'add_alert',
            required_permissions: ['push.create'],
        },
        {
            title: 'SIDENAV.NAVIGATIONS',
            path: 'navigations',
            weight: 180,
            icon: 'menu',
            required_permissions: ['navigations.create'],
        },
        {
            title: 'SIDENAV.APPLINKS',
            path: 'posts',
            queryParams: { type: 'approute' },
            weight: 250,
            icon: 'touch_app',
            required_permissions: ['approute.create'],
        },
        {
            title: 'Media',
            method: 'openMediaDialog',
            weight: 180,
            icon: 'perm_media',
            required_permissions: [],
        },
    ],
};
